module.exports = "/_next/static/images/bgPhone-44dac807cf8a305bcfac5d475b6c70db.png.webp";